"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "15",
    viewBox: "0 0 14.254 15",
    width: "14.254",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#004864"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m9.1 0a4.611 4.611 0 0 0 -4.6 4.6c0 2.414 4.2 8.793 4.368 9.08a.287.287 0 0 0 .46 0c.172-.289 4.372-6.611 4.372-9.08a4.611 4.611 0 0 0 -4.6-4.6zm0 6.609a2.036 2.036 0 0 1 -2.014-2.009 2.011 2.011 0 1 1 4.023 0 2.036 2.036 0 0 1 -2.009 2.009z",
    transform: "translate(-1.914)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m7.184 23.974c-.284 0-7.184-.058-7.184-1.495q0-1.034 4.138-1.379a.287.287 0 1 1 0 .575c-2.759.23-3.563.69-3.621.8.172.287 2.529.862 6.609.862s6.437-.575 6.609-.92c-.057-.115-.862-.517-3.621-.747a.287.287 0 1 1 0-.575q4.138.345 4.138 1.379c.116 1.442-6.781 1.5-7.068 1.5z",
    transform: "translate(0 -8.974)"
  })));
};

exports["default"] = _default;